/**
 * Product Launch Countdown Timer
 * Displays countdown timer for products with release_date metafield
 */

class ProductCountdown {
  constructor(element) {
    this.element = element;
    this.releaseDate = new Date(element.dataset.releaseDate);
    this.dateValueElement = element.querySelector('.product-countdown__date-value');
    this.daysElement = element.querySelector('[data-countdown-days]');
    this.hoursElement = element.querySelector('[data-countdown-hours]');
    this.minutesElement = element.querySelector('[data-countdown-minutes]');
    this.secondsElement = element.querySelector('[data-countdown-seconds]');

    this.init();
  }

  init() {
    // Check if release date is valid and in the future
    if (isNaN(this.releaseDate.getTime())) {
      return; // Invalid date, don't show countdown
    }

    const now = new Date();
    if (this.releaseDate <= now) {
      return; // Date is in the past, don't show countdown
    }

    // Format and display the release date
    this.displayReleaseDate();

    // Start the countdown
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);

    // Show the countdown element
    this.element.style.display = 'block';
  }

  displayReleaseDate() {
    // Format date based on locale
    const options = { year: 'numeric', month: 'short', day: '2-digit' };
    const formattedDate = this.releaseDate.toLocaleDateString(document.documentElement.lang || 'es', options);
    this.dateValueElement.textContent = formattedDate;
  }

  updateCountdown() {
    const now = new Date();
    const difference = this.releaseDate - now;

    // If countdown has finished, hide the element and stop the interval
    if (difference <= 0) {
      this.element.style.display = 'none';
      clearInterval(this.interval);
      return;
    }

    // Calculate time units
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    // Update the display
    this.daysElement.textContent = days;
    this.hoursElement.textContent = hours;
    this.minutesElement.textContent = minutes;
    this.secondsElement.textContent = seconds;
  }

  destroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

// Initialize all countdown timers on the page
function initProductCountdowns() {
  const countdownElements = document.querySelectorAll('.product-countdown[data-release-date]');

  countdownElements.forEach(element => {
    new ProductCountdown(element);
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductCountdowns);
} else {
  initProductCountdowns();
}

// Re-initialize when new products are loaded dynamically (e.g., via AJAX)
document.addEventListener('shopify:section:load', initProductCountdowns);
